import { render } from "./AdminAccounts.vue?vue&type=template&id=708cc198"
import script from "./AdminAccounts.vue?vue&type=script&lang=js"
export * from "./AdminAccounts.vue?vue&type=script&lang=js"

import "./AdminAccounts.vue?vue&type=style&index=0&id=708cc198&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__